import React, { useCallback, useMemo } from "react";
import { ModalV2, Text } from "@jsq/ds/core";
import { Form } from "@jsq/ds/forms";
import { CancelRequestFormContent } from "./CancelRequestFormContent";
import { getCancelRequestValidationSchema } from "./schema";
import { modalHeader, modalSubtitle } from "./styles_vanilla.css";
import { BaseCancelRequestModalProps, BaseCancelRequestFormValues } from "./types";

export const BaseCancelRequestModal: React.FC<BaseCancelRequestModalProps> = ({
  show,
  onHide,
  title,
  subtitle,
  recipients,
  onCancel,
  loading = true,
}) => {
  const formInitialValues: BaseCancelRequestFormValues = useMemo(
    () => ({
      comment: "",
      caseRetention: null,
    }),
    [],
  );

  const handleSubmit = useCallback(
    async (values: BaseCancelRequestFormValues) => {
      try {
        await onCancel(values);
      } catch {
        // Error handling is done in the parent component
      }
    },
    [onCancel],
  );

  return (
    <ModalV2
      show={show}
      onHide={onHide}
      isCentered={true}
      size="medium"
      backdrop={true}
      title={title}
      headerClassName={modalHeader}
    >
      <Form<BaseCancelRequestFormValues>
        initialValues={formInitialValues}
        onSubmit={handleSubmit}
        yupValidationSchema={getCancelRequestValidationSchema}
        submitOnlyChangedValues={false}
      >
        <ModalV2.Body>
          {subtitle && (
            <Text variant="regular-md" className={modalSubtitle}>
              {subtitle}
            </Text>
          )}
          <CancelRequestFormContent
            recipients={recipients}
            onClose={onHide}
            loading={loading}
          />
        </ModalV2.Body>
      </Form>
    </ModalV2>
  );
};
